import * as React from "react";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Visibility from "@mui/icons-material/Visibility";
import { MenuItem } from "@mui/material";
import { Delete, Payment, UpdateTwoTone, Edit } from "@mui/icons-material";
import { Link } from "react-router-dom";

export default function ActionsPopover({
  itemId, // The ID of the item (e.g., campaign, user, etc.)
  onDelete, // Callback function to handle delete action
  onDuplicate, // Callback function to handle duplicate action
  viewPath, // Route path for the "View" action
  editPath, // Route path for the "Edit" action
  canEdit = true, // Boolean to control if edit action should be shown
  canDelete = false, // Boolean to control if delete action should be shown
  canDuplicate = false, // Boolean to control if duplicate action should be shown
  isPaid = false, // Boolean to indicate if payment action should be shown
  canPay = false,
  canPushToManifest = false,
  onManifestPush,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    handleClose();
    if (onDelete) {
      onDelete(itemId); // Call the provided delete function
    }
  };

  const handleDuplicate = () => {
    handleClose();
    if (onDuplicate) {
      onDuplicate(itemId); // Call the provided duplicate function
    }
  };

  const handlePushManifest = () => {
    handleClose();
    if (canPushToManifest) {
      onManifestPush(itemId);
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Button aria-describedby={id} variant="" onClick={handleClick}>
        <MoreVertIcon />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {/* View action */}
        {viewPath && (
          <Link
            style={{ textDecoration: "none", color: "black" }}
            to={viewPath}
          >
            <MenuItem sx={{ display: "flex", gap: 1 }} onClick={handleClose}>
              <Visibility sx={{ fontSize: 16 }} />
              View
            </MenuItem>
          </Link>
        )}

        {/* Pay action */}
        {isPaid === false && canPay && (
          <Link
            style={{ textDecoration: "none", color: "black" }}
            to={`/payment/${itemId}`}
          >
            <MenuItem sx={{ display: "flex", gap: 1, color: "success.main" }}>
              <Payment sx={{ fontSize: 16 }} />
              Proceed to checkout
            </MenuItem>
          </Link>
        )}

        {/* Delete action */}
        {canDelete && (
          <MenuItem
            sx={{ display: "flex", gap: 1, color: "error.main" }}
            onClick={handleDelete}
          >
            <Delete sx={{ fontSize: 16 }} />
            Delete
          </MenuItem>
        )}

        {/* Edit action */}
        {editPath && canEdit && (
          <Link
            style={{ textDecoration: "none", color: "black" }}
            to={editPath}
          >
            <MenuItem sx={{ display: "flex", gap: 1, color: "warning.main" }}>
              <Edit />
              Edit
            </MenuItem>
          </Link>
        )}

        {/* Duplicate action */}
        {canDuplicate && (
          <MenuItem
            onClick={handleDuplicate}
            sx={{ display: "flex", gap: 1, color: "warning.main" }}
          >
            <UpdateTwoTone sx={{ fontSize: 16 }} />
            Duplicate
          </MenuItem>
        )}

        {canPushToManifest && (
          <MenuItem
            onClick={handlePushManifest}
            sx={{ display: "flex", gap: 1, color: "warning.main" }}
          >
            <UpdateTwoTone sx={{ fontSize: 16 }} />
            Push To Manifest
          </MenuItem>
        )}
      </Popover>
    </div>
  );
}
